import { ButtonConfig, Icon, RightsEnum } from '../../../../global';

export const selectionBottomBarButtons: Array<ButtonConfig> = [
  {
    buttonStyle: 'transparent-blue',
    action: 'delete',
    label: 'INVOICE.DELETE',
    height: 'normal',
    icon: Icon.DELETE,
    align: 'left'
  },
  {
    buttonStyle: 'secondary',
    action: 'back',
    label: 'LBL_BTN.CANCEL',
    testId: 'cancelButton',
    height: 'normal',
    align: 'right'
  },
  {
    buttonStyle: 'primary',
    action: 'save',
    label: 'LBL_UPLOAD_FILL.FILLING.DATA.SAVE',
    testId: 'saveButton',
    height: 'normal',
    align: 'right',
    rights: [RightsEnum.DOCUMENT_RECORDING_WRITE]
  }
];

export const MODIFIED_ERROR_LABEL = 'version_lock_mismatch';
